import { CheckCircle } from "lucide-react";
import { useState } from "react";

export default function AboutCTA() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    url: "",
    budget: "",
    scope: "",
    details: "",
  });
  const [formSent, setFormSent] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);

  const CL =
    "https://calendar.google.com/calendar/appointments/schedules/AcZssZ1P3lnVUA-HnHlnVIwLcyxtvGs2WlLsbQXzDw92sYlEUILA90KSdqaieo5qmRkckf8xQgQ0ti8_?gv=true";
  const WA =
    "https://wa.me/8801837127779?text=Hi%20TechTCL%2C%20I%27m%20interested%20in%20discussing%20a%20project.";

  const handleSubmit = () => {
    if (!formData.name || !formData.email || !formData.budget) return;
    const apiBase =
      window.location.hostname === "localhost"
        ? "http://localhost:8081"
        : "/api";
    fetch(`${apiBase}/save-lead.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...formData, source: "homepage-contact" }),
    }).catch(() => {});
    setFormSent(true);
  };

  const labelStyle = {
    fontSize: 12,
    fontWeight: 600,
    color: "#5E5A54",
    marginBottom: 6,
    display: "block",
  };
  const inputStyle = {
    width: "100%",
    padding: "12px 16px",
    borderRadius: 10,
    border: "1.5px solid #E0DCD6",
    fontSize: 14,
    outline: "none",
    background: "#fff",
    transition: "border-color .3s",
  };
  const selectStyle = {
    ...inputStyle,
    appearance: "none",
    WebkitAppearance: "none",
    backgroundImage:
      "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%238A857E' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 16px center",
  };

  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700;800&family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400;1,700&display=swap"
        rel="stylesheet"
      />

      {/* Calendar Popup */}
      {showCalendar && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 99999,
            background: "rgba(0,0,0,.6)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
          }}
          onClick={() => setShowCalendar(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: 16,
              width: "100%",
              maxWidth: 700,
              maxHeight: "90vh",
              overflow: "hidden",
              boxShadow: "0 24px 80px rgba(0,0,0,.25)",
              position: "relative",
            }}
          >
            <button
              onClick={() => setShowCalendar(false)}
              style={{
                position: "absolute",
                top: 12,
                right: 16,
                background: "#f5f5f5",
                border: "none",
                width: 32,
                height: 32,
                borderRadius: "50%",
                fontSize: 18,
                cursor: "pointer",
                zIndex: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              ×
            </button>
            <iframe
              src={CL}
              style={{ border: 0, width: "100%", height: "600px" }}
              title="Book a Strategy Call"
            />
          </div>
        </div>
      )}

      {/* Green Header */}
      <section
        id="booking"
        style={{
          padding: "90px 28px 0",
          background: "linear-gradient(170deg, #1e3c72, #2563eb)",
        }}
      >
        <div
          style={{
            maxWidth: 900,
            margin: "0 auto",
            textAlign: "center",
            paddingBottom: 50,
          }}
        >
          <h2
            style={{
              fontSize: "clamp(28px,3.5vw,38px)",
              color: "#fff",
              marginBottom: 8,
              lineHeight: 1.2,
            }}
          >
            Let's Build Something Great
          </h2>
          <p
            style={{
              fontSize: 15,
              color: "rgba(255,255,255,.55)",
              marginBottom: 8,
            }}
          >
            Start with a conversation — no commitment required.
          </p>
        </div>
      </section>

      {/* White Card */}
      <section
        className="about-white-card-main"
        style={{
          padding: "0 28px",
          marginTop: -50,
          position: "relative",
          zIndex: 10,
          paddingBottom: 60,
        }}
      >
        <div
          className="contact-form-card"
          style={{
            maxWidth: 900,
            margin: "0 auto",
            background: "#fff",
            borderRadius: 20,
            padding: "52px 44px",
            boxShadow: "0 4px 30px rgba(0,0,0,.06)",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: 36 }}>
            <span
              style={{
                fontSize: 12,
                letterSpacing: 3,
                color: "#2563eb",
                textTransform: "uppercase",
                fontWeight: 700,
              }}
            >
              Get Started
            </span>
            <h2
              style={{
                fontSize: "clamp(28px,4vw,40px)",
                marginTop: 8,
                marginBottom: 12,
                lineHeight: 1.2,
              }}
            >
              Ready to Scale Your Revenue?
            </h2>
            <p
              style={{
                fontSize: 15,
                color: "#8A857E",
                maxWidth: 520,
                margin: "0 auto",
              }}
            >
              Fill out the form below and we'll get back within 24 hours with a
              custom proposal — or book a call directly.
            </p>
          </div>

          <div
            className="contact-grid-layout"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 40,
              alignItems: "start",
            }}
          >
            {/* LEFT — Form */}
            <div>
              {!formSent ? (
                <div>
                  <div style={{ display: "grid", gap: 14 }}>
                    <div>
                      <label style={labelStyle}>Your Name *</label>
                      <input
                        style={inputStyle}
                        placeholder="John Smith"
                        value={formData.name}
                        onChange={(e) =>
                          setFormData({ ...formData, name: e.target.value })
                        }
                      />
                    </div>
                    <div>
                      <label style={labelStyle}>Email Address *</label>
                      <input
                        style={inputStyle}
                        type="email"
                        placeholder="john@yourbrand.com"
                        value={formData.email}
                        onChange={(e) =>
                          setFormData({ ...formData, email: e.target.value })
                        }
                      />
                    </div>
                    <div>
                      <label style={labelStyle}>Store URL</label>
                      <input
                        style={inputStyle}
                        placeholder="yourbrand.myshopify.com"
                        value={formData.url}
                        onChange={(e) =>
                          setFormData({ ...formData, url: e.target.value })
                        }
                      />
                    </div>
                    <div>
                      <label style={labelStyle}>Budget Range *</label>
                      <select
                        style={selectStyle}
                        value={formData.budget}
                        onChange={(e) =>
                          setFormData({ ...formData, budget: e.target.value })
                        }
                      >
                        <option value="" disabled>
                          Select your budget range
                        </option>
                        <option value="1k-3k">$1,000 – $3,000</option>
                        <option value="3k-5k">$3,000 – $5,000</option>
                        <option value="5k-10k">$5,000 – $10,000</option>
                        <option value="10k-25k">$10,000 – $25,000</option>
                        <option value="25k+">$25,000+</option>
                        <option value="retainer">Monthly Retainer</option>
                        <option value="custom">Custom / Not Sure</option>
                      </select>
                    </div>
                    <div>
                      <label style={labelStyle}>What do you need?</label>
                      <select
                        style={selectStyle}
                        value={formData.scope}
                        onChange={(e) =>
                          setFormData({ ...formData, scope: e.target.value })
                        }
                      >
                        <option value="" disabled>
                          Select project scope
                        </option>
                        <option value="new-store">New Store Build</option>
                        <option value="redesign">Store Redesign</option>
                        <option value="cro">CRO & Optimization</option>
                        <option value="custom-dev">Custom Development</option>
                        <option value="migration">Platform Migration</option>
                        <option value="other">Something Else</option>
                      </select>
                    </div>
                    <div>
                      <label style={labelStyle}>Tell us more (optional)</label>
                      <textarea
                        style={{
                          ...inputStyle,
                          resize: "vertical",
                          minHeight: 80,
                        }}
                        rows={3}
                        placeholder="Brief description of your project..."
                        value={formData.details}
                        onChange={(e) =>
                          setFormData({ ...formData, details: e.target.value })
                        }
                      />
                    </div>
                  </div>
                  <button
                    onClick={handleSubmit}
                    style={{
                      width: "100%",
                      marginTop: 18,
                      padding: "16px",
                      borderRadius: 14,
                      border: "none",
                      background: "linear-gradient(135deg, #1e3c72, #2563eb)",
                      color: "#fff",
                      fontSize: 16,
                      fontWeight: 700,
                      cursor:
                        formData.name && formData.email && formData.budget
                          ? "pointer"
                          : "not-allowed",
                      opacity:
                        formData.name && formData.email && formData.budget
                          ? 1
                          : 0.5,
                      transition: "all .3s",
                    }}
                  >
                    Submit Inquiry →
                  </button>
                  <p
                    style={{
                      fontSize: 11,
                      color: "#B5AFA8",
                      textAlign: "center",
                      marginTop: 10,
                    }}
                  >
                    We respond within 24 hours. Your data is never shared.
                  </p>
                </div>
              ) : (
                <div
                  style={{
                    background: "#eff6ff",
                    borderRadius: 18,
                    padding: "40px 28px",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      marginBottom: 16,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <CheckCircle size={48} color="#16a34a" />
                  </div>
                  <h3
                    style={{ fontSize: 22, color: "#1e3c72", marginBottom: 10 }}
                  >
                    Inquiry Sent!
                  </h3>
                  <p
                    style={{ fontSize: 14, color: "#5E5A54", lineHeight: 1.7 }}
                  >
                    We've received your project details. Expect a response
                    within 24 hours with a custom proposal.
                  </p>
                  <button
                    onClick={() => {
                      setFormSent(false);
                      setFormData({
                        name: "",
                        email: "",
                        url: "",
                        budget: "",
                        scope: "",
                        details: "",
                      });
                    }}
                    style={{
                      marginTop: 16,
                      padding: "10px 28px",
                      borderRadius: 50,
                      border: "1.5px solid #D5D0C8",
                      background: "transparent",
                      color: "#2563eb",
                      fontSize: 13,
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                  >
                    Submit Another Inquiry
                  </button>
                </div>
              )}
            </div>

            {/* RIGHT — Quick Contact + Investment + Social */}
            <div>
              {/* Quick contact */}
              <div
                style={{
                  background: "#F8F6F2",
                  borderRadius: 18,
                  padding: "28px 24px",
                  marginBottom: 20,
                }}
              >
                <h3
                  style={{
                    fontSize: 16,
                    fontWeight: 700,
                    color: "#3D4A35",
                    marginBottom: 16,
                  }}
                >
                  Prefer to talk directly?
                </h3>
                <div style={{ display: "grid", gap: 10 }}>
                  <div
                    onClick={() => setShowCalendar(true)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                      padding: "14px 16px",
                      borderRadius: 12,
                      background: "#fff",
                      border: "1.5px solid #E0DCD6",
                      cursor: "pointer",
                      transition: "all .3s",
                    }}
                  >
                    <div
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: 10,
                        background: "#4285F4",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="#fff"
                      >
                        <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zM9 14H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm-8 4H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z" />
                      </svg>
                    </div>
                    <div>
                      <div
                        style={{
                          fontSize: 14,
                          fontWeight: 600,
                          color: "#3D4A35",
                        }}
                      >
                        Book a Strategy Call
                      </div>
                      <div style={{ fontSize: 12, color: "#8A857E" }}>
                        30-min free consultation
                      </div>
                    </div>
                  </div>
                  <a
                    href={WA}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                      padding: "14px 16px",
                      borderRadius: 12,
                      background: "#fff",
                      border: "1.5px solid #E0DCD6",
                      textDecoration: "none",
                      transition: "all .3s",
                    }}
                  >
                    <div
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: 10,
                        background: "#25D366",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="#fff"
                      >
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                      </svg>
                    </div>
                    <div>
                      <div
                        style={{
                          fontSize: 14,
                          fontWeight: 600,
                          color: "#3D4A35",
                        }}
                      >
                        WhatsApp Us
                      </div>
                      <div style={{ fontSize: 12, color: "#8A857E" }}>
                        Usually reply within 1 hour
                      </div>
                    </div>
                  </a>
                  <a
                    href="mailto:support@techtcl.com?subject=Project%20Inquiry"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                      padding: "14px 16px",
                      borderRadius: 12,
                      background: "#fff",
                      border: "1.5px solid #E0DCD6",
                      textDecoration: "none",
                      transition: "all .3s",
                    }}
                  >
                    <div
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: 10,
                        background: "#EA4335",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="#fff"
                      >
                        <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                      </svg>
                    </div>
                    <div>
                      <div
                        style={{
                          fontSize: 14,
                          fontWeight: 600,
                          color: "#3D4A35",
                        }}
                      >
                        Email Us
                      </div>
                      <div style={{ fontSize: 12, color: "#8A857E" }}>
                        support@techtcl.com
                      </div>
                    </div>
                  </a>
                </div>
              </div>

              {/* Map */}
              <div
                style={{
                  borderRadius: 18,
                  overflow: "hidden",
                  marginBottom: 20,
                  border: "1.5px solid #E0DCD6",
                }}
              >
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d383.65631526986414!2d90.37099578530605!3d23.819503709076347!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c1004cbdc581%3A0x32fe287e50f070c6!2sSuja%20Bhai%20Flat!5e0!3m2!1sen!2sbd!4v1771837220650!5m2!1sen!2sbd"
                  style={{
                    border: 0,
                    width: "100%",
                    height: 180,
                    display: "block",
                  }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="TechTCL Office"
                />
              </div>

              {/* Social */}
              <div style={{ textAlign: "center" }}>
                <p
                  style={{
                    fontSize: 12,
                    color: "#B5AFA8",
                    textTransform: "uppercase",
                    letterSpacing: 1.5,
                    marginBottom: 12,
                  }}
                >
                  Find Us On
                </p>
                <div
                  className="contact-social-links"
                  style={{ display: "flex", gap: 8, justifyContent: "center" }}
                >
                  <a
                    href="https://www.linkedin.com/in/noyonuzzaman-techtcl/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 6,
                      padding: "7px 14px",
                      borderRadius: 50,
                      border: "1.5px solid #D5D0C8",
                      color: "#0A66C2",
                      fontSize: 12,
                      fontWeight: 600,
                      textDecoration: "none",
                      background: "#F8F6F2",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="#0A66C2"
                    >
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                    </svg>
                    LinkedIn
                  </a>
                  <a
                    href="https://www.techtcl.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 6,
                      padding: "7px 14px",
                      borderRadius: 50,
                      border: "1.5px solid #D5D0C8",
                      color: "#2563eb",
                      fontSize: 12,
                      fontWeight: 600,
                      textDecoration: "none",
                      background: "#F8F6F2",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="#2563eb"
                    >
                      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm-1 17.93c-3.945-.492-7-3.861-7-7.93 0-.669.085-1.318.243-1.94L8 12v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H9v-2h2c.55 0 1-.45 1-1V5h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
                    </svg>
                    TechTCL.com
                  </a>
                  <a
                    href="https://www.facebook.com/profile.php?id=61578997427316"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 6,
                      padding: "7px 14px",
                      borderRadius: 50,
                      border: "1.5px solid #D5D0C8",
                      color: "#1877F2",
                      fontSize: 12,
                      fontWeight: 600,
                      textDecoration: "none",
                      background: "#F8F6F2",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="#1877F2"
                    >
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                    Facebook
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
